module.exports = __webpack_public_path__ + "media/images/icons/church-0a1f75be4fe1cfc1eee7eb086a107e54.svg";